var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"type":"text","autocomplete":"one-time-code","inputmode":_vm.inputmode,"maxlength":_vm.maxlength,"placeholder":"1234"},domProps:{"value":_vm.value}})}
var staticRenderFns = []

export { render, staticRenderFns }